export default __webpack_public_path__ + "static/media/IMG_05_th.458a2dfb.jpg";